"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContinueBox = exports.BodyBox = exports.Hr = exports.LeavingModal = exports.Continue = exports.NoThanks = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Modal = _interopRequireDefault(require("../Modal"));

var _Anchor = _interopRequireDefault(require("../../Elements/Anchor"));

var _Button = _interopRequireDefault(require("../../Elements/Button"));

var _Divider = _interopRequireDefault(require("../../Elements/Divider"));

var _Box = _interopRequireDefault(require("../../Layout/Box"));

var _breakpoints = require("../../theme/variables/breakpoints");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NoThanks = (0, _styledComponents.default)(_Anchor.default).attrs({
  mr: [0, 8],
  my: [1, 0]
})(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-size: 18px;\n  color: ", ";\n  text-transform: uppercase;\n"], ["\n  font-size: 18px;\n  color: ", ";\n  text-transform: uppercase;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
exports.NoThanks = NoThanks;
var Continue = (0, _styledComponents.default)(_Button.default)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  font-size: 24px;\n  width: 100%;\n  margin-bottom: 20px;\n\n  ", " {\n    width: 212px;\n    margin-bottom: 0;\n  }\n"], ["\n  font-size: 24px;\n  width: 100%;\n  margin-bottom: 20px;\n\n  ", " {\n    width: 212px;\n    margin-bottom: 0;\n  }\n"])), _breakpoints.mediaQueries[0]);
exports.Continue = Continue;
var LeavingModal = (0, _styledComponents.default)(_Modal.default)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  margin: 48px 12px;\n  width: auto;\n\n  ", " {\n    margin: 5% auto;\n  }\n"], ["\n  margin: 48px 12px;\n  width: auto;\n\n  ", " {\n    margin: 5% auto;\n  }\n"])), _breakpoints.mediaQueries[0]);
exports.LeavingModal = LeavingModal;
var Hr = (0, _styledComponents.default)(_Divider.default)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  border-color: #b4adaa;\n  width: 90%;\n  max-width: 400px;\n  margin: 24px auto;\n"], ["\n  border-color: #b4adaa;\n  width: 90%;\n  max-width: 400px;\n  margin: 24px auto;\n"])));
exports.Hr = Hr;
var BodyBox = (0, _styledComponents.default)(_Box.default)(templateObject_5 || (templateObject_5 = (0, _tslib.__makeTemplateObject)(["\n  margin-bottom: 32px;\n  font-size: 18px;\n  text-align: center;\n  line-height: 1.2;\n"], ["\n  margin-bottom: 32px;\n  font-size: 18px;\n  text-align: center;\n  line-height: 1.2;\n"])));
exports.BodyBox = BodyBox;
var ContinueBox = (0, _styledComponents.default)(_Box.default)(templateObject_6 || (templateObject_6 = (0, _tslib.__makeTemplateObject)(["\n  line-height: 1.2;\n  margin-bottom: 36px;\n  text-align: center;\n  font-size: 22px;\n\n  ", " {\n    margin-bottom: 80px;\n  }\n"], ["\n  line-height: 1.2;\n  margin-bottom: 36px;\n  text-align: center;\n  font-size: 22px;\n\n  ", " {\n    margin-bottom: 80px;\n  }\n"])), _breakpoints.mediaQueries[0]);
exports.ContinueBox = ContinueBox;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;